import { render } from "./MyBooking.vue?vue&type=template&id=66b71ab9&scoped=true"
import script from "./MyBooking.vue?vue&type=script&lang=js"
export * from "./MyBooking.vue?vue&type=script&lang=js"

import "./MyBooking.vue?vue&type=style&index=0&id=66b71ab9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b71ab9"]])

export default __exports__